"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const ClearableInput_1 = tslib_1.__importDefault(require("../clearableInput/ClearableInput"));
const TreeSearch = react_1.default.memo(props => {
    const { value, className, placeholder, onChange } = props;
    const classes = (0, classnames_1.default)('TreeSearch', className);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'input-group flex-1-0' }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'input-group-addon' }, { children: (0, jsx_runtime_1.jsx)("span", { className: 'rioglyph rioglyph-search', "aria-hidden": 'true' }) })), (0, jsx_runtime_1.jsx)(ClearableInput_1.default, { value: value, onChange: onChange, placeholder: placeholder })] })) })));
});
TreeSearch.displayName = 'TreeSearch';
TreeSearch.defaultProps = {
    onChange: () => { },
};
TreeSearch.propTypes = {
    value: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    placeholder: prop_types_1.default.string,
    className: prop_types_1.default.string,
};
exports.default = TreeSearch;
